import React from 'react';
import "./BookNowDR.css" 

const BookNowDR = () => {
    return (
        <div>
            <h2>This is a booknow</h2>
        </div>
    );
};
 

export default BookNowDR;